export const emptyField = { field: null, op: null, value: null };

// A fresh "has related record" (reverse EXISTS) filter node. The backend list
// grammar accepts `{exists: {relation, where}}` (and `{not: {exists: ...}}` for
// NOT EXISTS); the nested `where` reuses the very same grammar recursively. See
// sarest/table/select_mixin.py _get_exists_filter_condition and the
// operator-task-exists-filter-graphql-advsearch-fe-parity task.
export const emptyExists = { exists: { relation: null, where: { and: [emptyField] } } };

export const operatorsList = [
    { value: "like", label: "Like" },
    { value: "notlike", label: "Not like" },
    { value: "eq", label: "Is" },
    { value: "neq", label: "Is not" },
    { value: "in", label: "In" },
    { value: "notin", label: "Not in" },
    { value: "lt", label: "Less than" },
    { value: "lte", label: "Less than or equal" },
    { value: "gt", label: "Greater than" },
    { value: "gte", label: "Greater than or equal" },
    { value: "set", label: "Is set" },
    { value: "unset", label: "Is not set" },
];
